import Logo from "./../assets/images/logo.svg";
import Cloud from "./../assets/images/cloud.png";
import PlusIcon from "./../assets/images/plus.svg";
import Delete from "./../assets/images/Delete.svg";
import Profile from "./../assets/images/profile.svg";
import Profile2 from "./../assets/images/profile2.svg";
import Clipboard from "./../assets/images/clipboard.svg";
import LogoWhite from "./../assets/images/logo-white.svg";
import DefaultImg from "./../assets/images/defaultImage.png";
import EmailFailed from "./../assets/images/email-failed.svg";
import Announcement from "./../assets/images/announcement.svg";
import EmailVerified from "./../assets/images/email-verified.svg";

const IMAGES = {
  Announcement,
  DefaultImg,
  Delete,
  Clipboard,
  Cloud,
  EmailFailed,
  EmailVerified,
  Logo,
  LogoWhite,
  PlusIcon,
  Profile,
  Profile2
};

export default IMAGES;
